import React from 'react';
import './About.css';
import { Fingerprint, Medal, Lightbulb, DraftingCompass } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <h2 className="section-title">من نحن</h2>
        <div className="about-content">
          <div className="strengths-section">
            <h3 className="strengths-title">نقاط قوة منتجاتنا</h3>
            <div className="strengths-grid">
              <div className="strength-item">
                <div className="strength-icon">
                  <DraftingCompass size={48} strokeWidth={1.5} />
                </div>
                <h4>للمهندسين، من قبل المهندسين</h4>
              </div>
              <div className="strength-item">
                <div className="strength-icon">
                  <Fingerprint size={48} strokeWidth={1.5} />
                </div>
                <h4>بسيط الاستخدام، متقدم بالتصميم</h4>
              </div>
              <div className="strength-item">
                <div className="strength-icon">
                  <Medal size={48} strokeWidth={1.5} />
                </div>
                <h4>عقود تراكمية من الخبرة</h4>
              </div>
              <div className="strength-item">
                <div className="strength-icon">
                  <Lightbulb size={48} strokeWidth={1.5} />
                </div>
                <h4>دائماً مبتكرون وليس مقلدون</h4>
              </div>
            </div>

            <a onClick={() => window.open('https://aquabroadcast.co.uk/company', '_blank')}
              className="read-more-btn">
              اقرأ المزيد عنا
            </a>
          </div>
          <div className="about-text">
            <h3 className="about-heading">مهمتنا في ثورة عالم البث الإذاعي</h3>
            <p className="about-description">
              في Aqua Broadcast، نحن في مهمة لإحداث ثورة في عالم مرسلات FM وصوت البث. مع التزام عميق بالابتكار والتميز،
              نتخصص في إنشاء منتجات عالية الجودة ومتطورة تضع معايير جديدة في الصناعة.
            </p>
            <p className="about-description">
              تأسست برؤية لدمج التكنولوجيا المتطورة بسلاسة مع المحتوى الديناميكي، نتخصص في تقديم منتجات عالية الجودة.
              مجموعة COBALT الحائزة على جوائز من مرسلات FM المكتملة الميزات وضعت معياراً جديداً بنظام التشغيل Linux المخصص.
            </p>

            <h4 className="about-subheading">صُنع من قبل المهندسين، للمهندسين</h4>
            <p className="about-description">
              في Aqua Broadcast، نعيش بشعار: "صُنع من قبل المهندسين، للمهندسين". مع فريق من المهندسين المهرة
              والمتخصصين في الصناعة الذين يتمتعون بأكثر من 100 عام من الخبرة التراكمية، نحن نفهم التحديات التقنية
              والمتطلبات التي تواجه المذيعين.
            </p>
            <p className="about-description">
              نحن لسنا مجرد مصنع منتجات؛ نحن شريك موثوق للمذيعين في جميع أنحاء العالم. التزامنا بدعم عملائنا
              يتجاوز مجرد بيع المنتج. نحن نأخذ الوقت لفهم الاحتياجات الفريدة لكل محطة، ونقدم حلولاً مخصصة
              ونوفر الدعم المستمر لمساعدتهم على تحقيق أهدافهم.
            </p>
            <p className="about-description">
              Aqua Broadcast تشكل مستقبلها الخاص، من أجلكم، عملاؤنا. مرسلاتنا مجهزة بميزات أمان الشبكة المتطورة،
              مما يوفر للمذيعين راحة البال في عالم متصل بشكل متزايد. بينما نواصل تطوير حلول جديدة، نهدف إلى
              توقع مستقبل البث وتقديم منتجات تتجاوز التوقعات.
            </p>

            <div className="testimonial">
              <blockquote>
                "هذه هي كاديلاك مرسلات LPFM، بلا شك"
              </blockquote>
              <cite>— Dave Solomon, WRTH South Carolina</cite>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
